import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PrinterSettingsDSData } from '../../../../@core/interfaces/masters/printersettingsds';

@Component({
  selector: 'ngx-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss']
})
export class SignatureComponent implements OnInit {

  protected readonly unsubscribe$ = new Subject<void>();
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  
  @Input() name: string;
  @ViewChild('sigPad') sigPad;
  sigPadElement;
  context;
  isDrawing:boolean = false;
  img:string = null;
  sign: boolean = false;
  coloCode:string = "000000";
  label:string = "Authorized By"
  sublabel:string=''
  isEdit=true;
  constructor(
    protected prdsSrvc:PrinterSettingsDSData,
  ) { }

  
  @Input() type: any;
  @Input() id: any; 
  @Input() pageName: any; 
  @Input() isSign: boolean=false; 
  ngOnInit(): void {
  }
   
  ngOnChanges(changes: any) {  
    if(this.type && this.id && this.pageName && this.isSign){
      var sign=JSON.parse(localStorage.getItem("EHR_Doctor_Sign"))
      // console.log("Sign component Store Sign  = ",sign);      
      if(sign!=null){
        var pglist=sign?.pages;
        var pageData=pglist?.filter(data=>data==this.pageName?.pageSetupFor);
        if(pageData?.length!=0){
          this.label=sign?.label;
          this.sublabel=sign?.sublabel
          this.img = sign?.img;
        }
      }else{
        this.loadFileData(this.type,this.id);  
      }
    }
        // this.loadFileData(this.type,this.id);  
  }
  loadFileData(refname,refId): void {
    // ////console.log("Page Lists = ", this.type, this.id, this.pageName);    
    ////console.log("ignature Page Lists = ", this.type," = ", this.id," - ",this.pageName,); 
    this.prdsSrvc.list(`PrinterSettingsDsMst/${this.tenantId}/${this.branchId}/${refname}/${refId}/${this.isEdit}/GetMethod`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      //console.log("Sign Data = ", data);   
      if(data!=null){
          var pglist=[];
          if(data?.dspage?.split(",")){
            pglist=data?.dspage?.split(",");
          }else{
            pglist.push(data?.dspage);
          }
          var pageData=pglist?.filter(data=>data==this.pageName?.pageSetupFor);
          ////console.log("Page Data =",pglist,pageData);      
          if(pageData?.length!=0){
            this.label=data?.dstitle;
            this.sublabel=data?.dsSubTitle
            this.img = 'data:image/jpeg;base64,' + data?.uploadedFile;
          }
          var signature={
            data:data,
            type:'doctor',
            id:refId,
            pages:pglist,
            label:data?.dstitle,
            sublabel:data?.dsSubTitle,
            img:'data:image/jpeg;base64,' + data?.uploadedFile,
          }
          localStorage.removeItem("EHR_Doctor_Sign");
          localStorage.setItem("EHR_Doctor_Sign",JSON.stringify(signature))

     }
    }, (error) => { 
      
    }, () => {
  
    });
  }

  openSign() {
    // document.getElementById("start").click();
    this.sign = true;
    this.sigPadElement = this.sigPad.nativeElement;
    this.context = this.sigPadElement.getContext('2d');
    this.context.strokeStyle = '#' + this.coloCode;
    // ////console.log(this.sigPadElement);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.isDrawing = false;
  }

  onMouseDown(e) {
    this.isDrawing = true;
    const coords = this.relativeCoords(e);
    this.context.moveTo(coords.x, coords.y);
  }

  onMouseMove(e) {
    if (this.isDrawing) {
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.context.stroke();
    }
  }

  private relativeCoords(event) {
    const bounds = event.target.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    return { x: x, y: y };
  }

  clear() {
    this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
    this.img = null;
  }

  save() {
    this.img = this.sigPadElement.toDataURL("image/png");
    this.sign = false
  }

  colorChange(code) {
    this.context.strokeStyle = '#' + code;
    this.coloCode = '#' + code;
  }
}
